import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  color?: string
}
export function LightningIcon({ color = '#101010' }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3219_529)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.45175 0.404816V5.42544H14.1257L6.54824 15.5952V10.5746H1.8743L9.45175 0.404816ZM4.86254 9.07456H8.04825V11.0715L11.1375 6.92544H7.95175V4.92851L4.86254 9.07456Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3219_529">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
